<template>
  <div id="app_content" class="reserved">
    <div class="container">
      <div class="row">
        <ul
            class="ch-menu"
            :class="openMenu ? 'active' : ''"
            @click="openMenu = !openMenu"
        >
          <li class="ch-menu-item">
            <a
                @click="goTo('cartid')"
                :class="active_element === 'cartid' ? 'active' : ''"
            >{{ trans.get("b2b.checkout.cart-prods") }}</a
            >
          </li>
          <!--          <li class="ch-menu-item">-->
          <!--            <a-->
          <!--              @click="goTo('giftid')"-->
          <!--              :class="active_element == 'giftid' ? 'active' : ''"-->
          <!--              >Prodotti in omaggio</a-->
          <!--            >-->
          <!--          </li>-->
          <li class="ch-menu-item">
            <a
                @click="goTo('ship_payid')"
                :class="active_element === 'ship_payid' ? 'active' : ''"
            >{{ trans.get("b2b.checkout.ship-pay") }}</a
            >
          </li>
        </ul>
        <div class="col-lg-9 offset-lg-3 col-md-12" id="cartid">
          <div class="ch-header">
<!--            <a :href="url('/b2b/')">{{ trans.get("b2b.checkout.ship-pay") }}</a>-->
            <h1>{{ trans.get("b2b.checkout.checkout") }}</h1>
            <span @click="openMenu = !openMenu" class="inactive">{{
                trans.get("b2b.checkout.menu")
              }}</span>
          </div>

          <div ref="element" class="ch-content">
            <h1 id="ship_payid">
              {{ trans.get("b2b.checkout.cart-prods") }}
            </h1>
            <b-loading :is-full-page="false" v-model="allLoaded"/>
            <div v-if="quantitaCart > 0" id="cart">
              <ch_cart
                  @loaded="loadCartItems"
                  @disponibilita="getDisponibilita"
                  :key="cartKey"
                  @totaleCarrello="updateCarrello"
                  @numArticoli="refreshQtaArticoli"
              />
            </div>
            <div v-else id="cart">
              {{ stopLoading() }}
              <p>{{ trans.get('b2b.checkout.no-items')}}</p>
            </div>

            <div id="ship_pay" v-if="cartItems">
              <section class="ship">
                <h1 id="ship_payid">
                  {{ trans.get("b2b.checkout.shipping-method") }}
                </h1>

                <div class=" sped selection d-flex align-items-center">
                  <b-field :label="$trans('b2b.checkout.select-date')">
                    <b-datepicker
                        v-model="datePicker"
                        :show-week-number="false"
                        placeholder="clicca per selezionare..."
                        icon="calendar-today"
                        :icon-right="datePicker ? 'close-circle' : ''"
                        icon-right-clickable
                        :min-date="new Date(Date.now() - 86400000)"
                        @icon-right-click="clearDate"
                        trap-focus
                    >
                    </b-datepicker>
                  </b-field>
                </div>

                <div class="selection body">
                  <div class="a-carico">
                    <input type="radio" name="ship_type" id="a_carico" value="a_carico" v-model="shipment">
                    <label for="a_carico">
                      {{ trans.get('b2b.checkout.4belt-ship') }}
                    </label>
                  </div>

                  <div class="cliente">
                    <input type="radio" name="ship_type" id="cliente" value="ritiro" v-model="shipment" @click="ritiroAddress">
                    <label for="cliente">
                     {{trans.get('b2b.checkout.select-own-ship')}}
                    </label>
                  </div>
                  <div class="address">
                    <input type="radio" name="address" @change="changeInputAddress($event)" value="db" id="db" v-model="address" checked>

                    <label for="db" class="txt-grey">
                      {{ trans.get("b2b.checkout.saved-address") }}
                    </label>

                    <b-select id="allAdresses" v-if="address === 'db'" icon="map-marker"
                              :placeholder="$trans('b2b.checkout.select-address')" v-model="currentAddress">
                      <option v-for="(addr, i) in indirizzi" :value="addr" :key="i">
                        {{
                          addr.indirizzo + " " + addr.cap + " - " + addr.localita
                        }}
                      </option>
                    </b-select>

                    <br/>
                    <input type="radio" name="address" value="newAddress" id="newAddress" v-model="address">

                    <label for="newAddress" class="txt-grey">
                      {{ trans.get("b2b.checkout.new-address") }}
                    </label>

                    <ValidationObserver v-slot="{ invalid }">
                      <form
                          v-if="address === 'newAddress'"
                          class="row newAddress align-items-baseline"
                          @submit.prevent="onSubmit"
                      >
                        <div class="form-group col-md-11 col-12 ">
                          <ValidationProvider
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <vue-google-autocomplete
                                id="insertAddress"
                                classname="form-control"
                                types="address"
                                :placeholder="placeholder"
                                v-on:placechanged="getAddressData"
                            >
                            </vue-google-autocomplete>
                            <!--                              <input-->
                            <!--                                  class="form-control"-->
                            <!--                                  :class="errors[0] ? 'invalid' : ''"-->
                            <!--                                  id="insertAddress"-->
                            <!--                                  type="text"-->
                            <!--                                  v-model="newAddress"-->
                            <!--                                  :placeholder="$trans('b2b.checkout.address')"-->
                            <!--                              />-->
                            <small class="my-caps">{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>

                      </form>
                    </ValidationObserver>
                    <p v-if="errShip" class="errore-sped">{{trans.get('b2b.checkout.err-addr')}}</p>
                  </div>
                  <div class="costo-spedizion">

                    <b-skeleton width="600px" height="50px" v-if="priceSkeleton"/>
                    <p v-if="(alpronto > 0 && nnpronto > 0) && !priceSkeleton">
                      <span >{{ trans.get('b2b.checkout.pronto')}}</span>
                      <span><strong>{{ alpronto.toLocaleString('it-IT', {minimumFractionDigits: 3}) }} €</strong></span>
                    </p>
                    <p v-if="(nnpronto > 0) && !priceSkeleton">
                      <span>{{ trans.get('b2b.checkout.nnpronto')}}</span>
                      <span ><strong>{{ nnpronto.toLocaleString('it-IT', {minimumFractionDigits: 3}) }} €</strong></span>
                    </p>
                    <p v-if=" ship_cost && !priceSkeleton">
                      <span>{{ trans.get('b2b.checkout.shipping-cost')}}</span>
                      <span><strong> {{ ship_cost.toLocaleString('it-IT', {minimumFractionDigits: 3}) }} €</strong></span>
                    </p>
                    <p v-if=" !priceSkeleton && !ship_cost"><span>{{ trans.get('b2b.checkout.shipping-cost')}} <strong>0,00 €</strong></span></p>

                    <p class="mt-1" v-if="isForeignCustomer">{{trans.get('b2b.checkout.foreign-customers-transport')}}</p>
                  </div>
                </div>
              </section>
              <section id="payment" class="pay">
                <h1>{{ trans.get("b2b.checkout.payment-method") }}</h1>
                <div class="selection d-flex justify-content-between">
                  <div class="left" v-for="(pag, i) in condizioniPagamento">
                    <input
                        type="radio"
                        name="payment"
                        :value="pag.cod_pagamento"
                        :id="pag.cod_pagamento"
                        @click="scrollNote"
                        v-model="payment"
                    />
                    <label :for="pag.cod_pagamento">{{
                        pag.descrizione_pag
                      }}</label>
                  </div>
                </div>
              </section>
              <section
                  id="note-cliente"
                  class="note-cliente"
                  v-if="payment !== ''"
              >
                <div class="selection d-flex justify-content-between">
                  <div class="left">
                    <b-field :label="$trans('b2b.checkout.add-info')">
                      <b-input
                          maxlength="200"
                          type="textarea"
                          v-model="noteCliente"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ch-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <ul v-if="totaleCarrello !== null" class="tot">
              <li class="cart"><span>{{ trans.get("b2b.checkout.cart") }}: </span>
                <span>{{ totaleCarrello.toLocaleString("it-IT", {minimumFractionDigits: 3}) }}€</span></li>
              <li class="ship"><span>{{ trans.get("b2b.checkout.shipping") }}: </span>
                <span>{{ ship_cost.toLocaleString("it-IT", {minimumFractionDigits: 3}) }}€</span></li>
              <li class="total"><span>{{ trans.get("b2b.checkout.total") }}</span> <span>{{ totaleOrdine }}€</span>
              </li>
            </ul>

            <!--              <span class="iva">{{ trans.get("b2b.checkout.vat") }}</span>-->

          </div>
          <div class="col-md-6 d-flex is-flex-direction-column">
            <a v-if="totaleCarrello !== null && currentAddress !== null && !priceSkeleton && !manteinance"
               class="link-ret checkout green btn btn-my-primary"
               @click="sendOrder"
               :class="ship_cost !== null && payment !== '' ? '' : 'disabled'">
              {{ trans.get("b2b.checkout.send-order") }}
            </a>
            <a v-else-if="manteinance" class="link-ret checkout green btn btn-my-primary disabled" >
              {{trans.get('b2b.checkout.mant-btn')}}
            </a>
            <a v-else-if="!manteinance"
               class="link-ret checkout green btn btn-my-primary disabled">
              {{ trans.get("b2b.checkout.send-order") }}
            </a>
            <div v-if="manteinance">
              <small>{{trans.get('b2b.checkout.mant-wrn')}}</small>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ch_cart from "./ch-cart";
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate";
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  components: {
    ch_cart,
    ValidationObserver,
    ValidationProvider,
    VueGoogleAutocomplete
  },
  data() {
    return {
      allLoaded: true,
      loading: null,
      isFullPage: false,
      cartKey: 0,
      quantitaCart: 0,
      totaleCarrello: 0,
      disponibilita: true,
      datePicker: new Date(),
      shipment: "a_carico",
      ship_cost: 0,
      active_element: "cartid",
      payment: null,
      anagrafica: null,
      currentRagioneSoc: null,
      indirizzi: null,
      cartItems: null,
      noteCliente: "",
      condizioniPagamento: null,
      currentCP: null,
      openMenu: false,
      peso: null,
      volume: null,
      articoli: null,
      scatole: null,
      currentAddress: null,
      level1: null,
      level2: null,
      country: null,
      PlaceId_level1: null,
      PlaceId_level2: null,
      PlaceId_country: null,
      scaglioni: null,
      standard_price: null,
      express_price: null,
      tentativo: 1,
      noRank: true,
      address: "db",
      validationOrder: {
        message: "",
        error: false,
      },
      newAddress: null,
      yesterdayDate: null,
      priceSkeleton: true,
      totaleOrdine: 0.00,
      placeholder: this.$trans('b2b.checkout.insert-address'),
      alpronto: null,
      nnpronto: null,
      circolino: true,
      manteinance: false,
      ora: null,
      minuto: null,
      errShip: false,
    };
  },
  watch: {
    quantitaCart: function (){
      if (this.quantitaCart === 0){
        console.log('carrello vuoto')
        location.reload()
      }
    },
    "$store.state.cartKey": function () {
      this.cartKey = this.$store.state.cartKey;
    },
    currentAddress: function () {
      this.getGoogleApi()
    },
    shipment: function () {
      if (this.shipment === "ritiro") {
        this.ship_cost = 0;
      } else if (this.shipment === 'a_carico'){
        this.calcolaSped()
      }
    },
    totaleCarrello: function () {
      this.totaleOrdine = this.calcTotOrd();
    },
    ship_cost: function () {
      this.totaleOrdine = this.calcTotOrd();

    },
    minuto: function () {
      if (this.ora === 23 && (this.minuto >= 55 && this.minuto <= 59) ){
        this.manteinance = true
      } else if (this.ora === 0 && this.minuto === 0){
        this.manteinance = true
      } else {
        this.manteinance = false
      }
    },
  },
  mounted() {

    this.getCart();
    this.calcolaTotCarrello();
    //document.getElementById("cartid").scrollIntoView(true);
    this.fetchAnagrafica();
    this.getShippingCost();
    this.totaleOrdine = this.calcTotOrd();

  },
  created() {
    setInterval(this.getNow, 1000)
  },
  computed: {
    isForeignCustomer() {
      return this.country !== null && this.country.toLowerCase() != 'italy'
    },
  },
  methods: {
    changeInputAddress(event){
      if (event.target.value === 'db'){
        $('#allAdresses option:first').attr('selected', 'selected')
      }

    },
    getNow(){
      let oggi = new Date();
      this.ora = oggi.getHours()
      this.minuto = oggi.getMinutes()
    },
    refreshQtaArticoli(value){
      this.quantitaCart = value
      this.priceSkeleton = true
    },
    stopLoading(){
      this.allLoaded = false
    },
    getAddressData(addressData, placeResultData, id) {
      //console.log(placeResultData)
      //console.log(id)
      //console.log(addressData)
      //console.log(placeResultData)
      this.newAddress = placeResultData.formatted_address
      this.getGoogleApi(true)
      // if (result.types.includes('country')){
      //   console.log(result.place_id, result.name)
      // } else {
      //   console.log('non valido')
      //   this.alertCustomError('Area non valida. Aree valide: stato, regione, provincia')
      // }

    },
    ritiroAddress(){
      this.shipment = 'ritiro'
      this.priceSkeleton = false
      this.ship_cost = 0
      this.alpronto = 0
      this.nnpronto = 0
      // this.currentAddress = {
      //   cap: '',
      //   indirizzo: '',
      //   num_progr: 0,
      //   rag_soc: this.indirizzi[0].rag_soc,
      //   localita: null,
      //   stato: '',
      //   provincia: '',
      // }
    },
    resetRadioSped() {
      this.ship_cost = null
      this.currentAddress = null

    },
    updateCarrello(value) {
      this.priceSkeleton = true
      this.totaleCarrello = value
    },

    calcTotOrd() {
      let totale = parseFloat(this.ship_cost + this.totaleCarrello)
      return totale.toLocaleString("it-IT", {
        minimumFractionDigits: 3,
      })
    },
    destroyCart: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/cart',
        params: {
          action: 'destroyCart'
        }
      }).then(res => {
        //console.log(res.data)
      }).catch(err => {
        console.log(err.response.data)
      })
    },
    getCart: function () {
      // this.loading = this.$buefy.loading.open({
      //   container: this.$refs.element.$el
      // });
      axios({
        method: "get",
        url: window.location.origin + "/b2b/cart",
        params: {
          action: "getCart",
        },
      }).then((res) => {
        if (res.data.status === 201) this.quantitaCart = res.data.data.length;
      });
    },
    getDisponibilita: function (status) {
      if (!status) {
        this.disponibilita = false;
      }
    },
    scrollNote: function () {
      setTimeout(() => {
        document.getElementById("note-cliente").scrollIntoView();
      }, 300);
    },
    loadCartItems: function (cartItems) {
      this.cartItems = cartItems;
      this.allLoaded = false

      this.getGoogleApi()
      // this.loading.close();
      //this.getPesoVolume();
      // setTimeout(() => {
      //   document.getElementById("ship_pay").scrollIntoView();
      // }, 300);
    },
    // selectShipType: function (type, cost) {
    //   this.ship_cost = {
    //     type: type,
    //     cost: cost,
    //   };
    //   setTimeout(() => {
    //     document.getElementById("payment").scrollIntoView();
    //   }, 300);
    //   if (type === "ritiro") {
    //     this.shipment = "ritiro";
    //   } else {
    //     this.shipment = "a_carico";
    //   }
    // },
    sendOrder: function () {
      if (this.currentAddress === null && this.shipment === 'a_carico') {
        this.validationOrder.error = true;
        this.validationOrder.message =
            "Seleziona o inserisci un indirizzo di spedizione";
      } else if (this.payment === "") {
        this.validationOrder.error = true;
        this.validationOrder.message = "Metodo di pagamento non selezionato";
      } else if (this.ship_cost === null) {
        this.validationOrder.error = true;
        this.validationOrder.message =
            "Tipologia di spedizione non selezionata";
      } /*else if (!this.disponibilita) {
        this.validationOrder.error = true;
        this.validationOrder.message =
          "Articoli non disponibili in carrello, per continuare eliminarli e riprovare";
      }*/
      if (this.validationOrder.error) {
        this.alertCustomError(this.validationOrder.message);
        this.validationOrder.error = false;
      } else {
        const loading = this.$buefy.loading.open();
        let orderObject = {};
        let customerInfo = {
          codClifor: this.anagrafica.cod_cli_for,
          numIndr: this.currentAddress.num_progr,
          ragSoc1: this.currentAddress.rag_soc,
          ragSoc2: this.currentAddress.rag_soc,
          indirizzo: this.currentAddress.indirizzo,
          localita: this.currentAddress.localita,
          cap: this.currentAddress.cap,
          provincia: this.currentAddress.provincia,
          codStato: this.currentAddress.cod_stato,
          noteCliente: this.noteCliente,
          speseTrasporto: [
            {
              data: this.datePicker
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
              costo: this.shipment === "a_carico" ? parseFloat(this.ship_cost) : 0.0,
              //spedizioneRapida: this.ship_cost.type === "express",
              spedizioneRapida: false,
              ritiraIlCliente: this.shipment === "ritiro",
            },
          ],
          promozioniTestata: [],
        };

        let listArticoliOrdine = [];
        this.cartItems.forEach((el, index) => {
          let tmpObj = {
            codArt: el.cod_art,
            qta: el.quantita,
            codCondizPagamento: this.payment,
            promozioniRiga: [],
            prezzoSenzaPromo: parseFloat(el.prezzo_unitario).toFixed(2),
            prezzoConPromo: parseFloat(el.prezzo_unitario).toFixed(2),
            importoNettoRiga: parseFloat(el.prezzo),
            dataConsegna: this.datePicker
                .toISOString()
                .slice(0, 19)
                .replace("T", " "),
            idRigaDoc: index + 1,
            qtaSpedita: 0,
            saldato: false,
          };
          listArticoliOrdine.push(tmpObj);
        });
        orderObject = {
          ...customerInfo,
          righe: listArticoliOrdine,
        };

        //console.log(orderObject)

        axios({
          method: "get",
          url: window.location.origin + "/b2b/sendOrder",
          params: {
            orderObject: orderObject,
          },
        })
            .then((res) => {
              //console.log(res.data);
              loading.close();
              if (res.data.success) {
                this.destroyCart()
                window.location.replace(window.location.origin + '/b2b/checkout-success')
              } else {
                this.alertCustomError(
                    "Errore nell'invio dell'ordine:" + res.data.message
                );
              }
            })
            .catch((err) => {
              loading.close();
              console.log(err.response.data)
              this.alertCustomError(err.response.data.message);
            });
      }
    },
    clearDate() {
      this.datePicker = null;
    },
    alertCustomError(message) {
      this.$buefy.dialog.alert({
        title: "Error",
        message: message,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    alertSuccess(message) {
      this.$buefy.dialog.alert({
        title: "Ordine inviato",
        message: message,
        type: "is-success",
        hasIcon: true,
        icon: "check-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    insertNewAddress: function () {
      this.currentAddress = this.newAddress;

      //console.log(this.currentAddress);
    },
    //FUNZIONE PER PRENDERE IL LISTINO STANDARD NEL CASO NON TROVI LE GEOAREA (deprecato per richieste del cliente)
    /*getGenericRanks: function () {
      if (this.tentativo === 1) {
        this.tentativo = 2;
        axios({
          method: "get",
          url: window.location.origin + "/b2b/getGenericRanks",
        })
          .then((res) => {
            if (res.data.ranks) {
              this.scaglioni = res.data.ranks;
              this.searchScaglione(this.scaglioni);
              console.log("ok riga 260");
            } else {
              console.log("no riga 262");
            }
          })
          .catch((err) => {
            console.log(err.response.data);
          });
      } else {
        console.log("Contattare il servizio clienti");
      }
    },*/
    searchScaglione: function (scaglione) {
      let ratio = this.peso / this.volume;
      ratio = ratio.toFixed(2);
      //console.log("ratio", ratio);
      scaglione.forEach((el) => {
        if (
            ratio >= el.min_weight_volume_ratio &&
            ratio <= el.max_weight_volume_ratio
        ) {
          //console.log("ok riga 278");
          this.noRank = false;
          this.express_price = el.express_price;
          this.standard_price = el.standard_price;
        }
      });
      if (this.noRank) {
        this.alertCustomError(
            "Scaglione non trovato, contattare il servizio clienti."
        );
      }
    },
    calcolaSped: function () {
      //vecchio metodo calcolo scaglioni dai place_id
      //this.getRanks(this.PlaceId_level1, this.PlaceId_level2, this.PlaceId_country);
      this.priceSkeleton = true
      this.alpronto = 0
      this.nnpronto = 0
      this.ship_cost = 0
      if (!this.PlaceId_country){
        this.alertCustomError("C''è stato un errore con il calcolo della spedizione: controllare indirizzo")
        return
      }
      if (!this.totaleCarrello){
        this.alertCustomError('I totali non sono stati calcolati')
        return;
      }
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/getPrices',
        params: {
          place_id: this.PlaceId_country,
          items: this.cartItems,
          tot_carrello: this.totaleCarrello,
        }
      }).then(res => {
        console.log(res.data)

        this.priceSkeleton = true
        this.alpronto = parseFloat((Math.ceil(res.data.alpronto*20)/20).toFixed(2))
        this.nnpronto = parseFloat((Math.ceil(res.data.nonpronto*20)/20).toFixed(2))
        this.ship_cost = parseFloat((Math.ceil(res.data.tot*20)/20).toFixed(2))
      }).catch(err => {
        console.log(err.response.data.message)
      }).finally(()=>{
        this.priceSkeleton = false
        //this.circolino = false
      })
    },
    getRanks: function (level1, level2, country) {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/getRanks",
        params: {
          place_id_1: level1,
          place_id_2: level2,
          country: country,
        },
      })
          .then((res) => {
            //console.log(res);
            if (res.data.ranks) {
              this.scaglioni = res.data.ranks;
              this.searchScaglione(this.scaglioni);
              //console.log("ok riga 304");
              //console.log(res.data);
            } else {
              //console.log("no riga 306");
              // this.getGenericRanks();
            }
          })
          .catch((err) => {
            //console.log(err.response.data);
            this.alertCustomError(err.response.data.message)
          });
    },
    getPlaceId: function (name, level) {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/getPlaceId",
        params: {
          address: name,
        },
      })
          .then((res) => {
            //console.log(res.data);

            if (level === 1) {
              this.PlaceId_level1 = res.data.place_id;
            } else if (level === 2) {
              this.PlaceId_level2 = res.data.place_id;
            } else if (level === 'country') {
              this.PlaceId_country = res.data.place_id;
            }
            if (this.shipment === 'a_carico') {
              this.calcolaSped()
            }
          })
          .catch((err) => {
            console.log(err.response.data);
          });
    },

    getGoogleApi: function (newAddress = false) {
      let currentAddress = null;
      this.errShip = false
      if (newAddress) {
        currentAddress = this.newAddress
        this.priceSkeleton = true
      } else {
        if (typeof this.currentAddress === "object") {
          currentAddress =
              this.currentAddress.indirizzo +
              ", " +
              this.currentAddress.cap +
              ", " +
              this.currentAddress.localita +
              ", " +
              this.currentAddress.provincia +
              ", " +
              this.currentAddress.cod_stato;
        } else {
          currentAddress = this.currentAddress;
        }
      }


      //console.log(currentAddress)
      axios({
        method: "get",
        url: window.location.origin + "/b2b/googleApi",
        params: {
          address: currentAddress,
        },
      })
          .then((res) => {
            //console.log(res.data);
            //this.level1 = res.data[0].level1;
            //this.level2 = res.data[0].level2;
            this.country = res.data[0].country;
            //this.getPlaceId(this.level2, 2);
            //this.getPlaceId(this.level1, 1);
            this.getPlaceId(this.country, 'country');
            //console.log(this.level1);
            //console.log(this.level2);
            if (newAddress) {
              this.currentAddress = {
                cap: res.data[0].cap,
                indirizzo: res.data[0].address + ', ' + res.data[0].civico,
                num_progr: 0,
                rag_soc: this.indirizzi[0].rag_soc,
                localita: res.data[0].localita,
                stato: res.data[0].stato,
                provincia: res.data[0].provincia,

              }
            }
          })
          .catch((err) => {
            console.log(err.response.data);
            this.errShip = true
          });
    },
    // imballi: function (values) {
    //   this.getPesoVolume(values.imballi);
    //   //console.log(this.imballi)
    // },

    getPesoVolume: function () {
      // console.log(this.cartItems)
      axios({
        method: "get",
        url: window.location.origin + "/b2b/calcVolPeso",
        params: {
          articles: this.cartItems,
        },
      })
          .then((res) => {
            //console.log(res.data.peso);
            //console.log(res.data.volume);
            //console.log(res.data)
            this.peso = res.data.peso;
            this.volume = res.data.volume;
          })
          .catch((err) => {
            console.log(err.response.data);
          });
    },
    onSubmit() {
      // console.log("ok");
    },

    getShippingCost: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/condPagamento",
      }).then((res) => {
         //console.log(res.data);
        this.condizioniPagamento = res.data;
        this.payment = res.data[0].cod_pagamento
      })
    },
    fetchAnagrafica: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/anagrafica",
      })
          .then((result) => {
            this.anagrafica = result.data.user;
            this.indirizzi = result.data.addresses;
            this.currentAddress = this.indirizzi[0]
            this.isLoaded = true;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    goTo: function (id) {
      document.getElementById(id).scrollIntoView(true);
      this.active_element = id;
    },
    calcolaTotCarrello: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/cart",
        params: {
          action: "getTotCart",
        },
      }).then((result) => {
        this.totaleCarrello = result.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.newAddress {
  small {
    color: var(--red);

    &.file-error {
      margin-left: -30px;
      margin-right: 20px;
    }
  }

  input {
    &:focus {
      border-color: var(--greenb2b);
      box-shadow: 0 0 0 0.2rem rgba(166, 249, 52, 0.25);
    }

    &.invalid {
      border-color: var(--red);
      box-shadow: 0 0 0 0.2rem rgba(255, 35, 61, 0.25);
    }
  }

  button.link-ret {
    padding: 10px;
    border: 1px solid #979797;
    // max-width: unset;


    &[disabled="disabled"] {
      display: none;
    }
  }
}

.reserved {
  a {
    color: #000;
  }

  #ship_pay section a.disabled {
    border: none;
    color: #edeff2;
    background-color: #c4c4c4;
  }

  .txt-grey {
    color: #71717f;
    margin: 15px 0;
  }

  ul.ch-menu {

    display: none;
    z-index: 9;
    background-color: #fff;

    &.active {
      display: block;
    }

    font-size: 16px;

    position: fixed;

    li {
      margin-top: 25px;

      a {
        font-size: 16px;
        color: #979797;

        &:before {
          content: "\25cf";
          margin-right: 10px;
          font-size: 14px;
        }

        &:hover,
        &:active {
          color: #0065ff;
        }

        &.active {
          color: #0065ff;
        }
      }
    }
  }

  .ch-header {
    padding-top: 25px;

    .inactive {
      display: inline;
    }

    span {
      position: absolute;
      cursor: pointer;
      left: 200px;
      top: 40px;
    }

    position: fixed;
    width: 100%; // 46vw
    background-color: #fff;
    z-index: 9;

    a {
      font-size: 14px;

      &:before {
        content: url("/media/icons/svg/caret-left-black.svg");
        margin-right: 15px;
      }
    }

    h1 {
      font-size: 34px;
      margin-top: 50px;
      margin-bottom: 25px;
    }
  }

  .ch-content {
    padding-top: 170px;
    padding-bottom: 120px;

    #cart {
      padding-bottom: 90px;
    }

    h1 {
      font-size: 21px;
    }

    #ship_pay {
      .ship {
        padding-bottom: 100px;
      }

      .type {
        .ipad {
          flex-wrap: wrap;
        }
      }

      .note-cliente {
        .left {
          width: 100%;
        }
      }

      .selection {
        font-size: 12px;
        flex-direction: column;
        background-color: #f2f2f2;
        padding: 30px 50px 30px 25px;
        .costo-spedizion {
          padding: 20px 0;
          position: relative;
        }
        &.sped {
          padding-bottom: 0;
        }

        &.body {
          display: flex;
          flex-direction: column;

        }

        .address {
          .newAddress {
            input {
              width: 100%;
              background-color: #fff;
              border-radius: 4px;
              border-color: #dbdbdb;
              padding-left: 1em;
              margin-top: 5px;

              &::placeholder {
                color: rgba(122, 122, 122, 0.7);
              }
            }
          }
          .errore-sped {
            color: var(--red);
          }
        }

        .details {
          margin-left: 40px;
        }
      }

      font-size: 16px;

      .address {
        a {
          padding: 10px;
          border: 1px solid #979797;
          max-width: unset;
          width: fit-content;

          &:after {
            margin-left: 30px;
          }

          img {
            margin-right: 15px;
          }
        }
      }
    }
  }

  .ch-footer {
    position: fixed;
    z-index: 5;
    bottom: 0;
    width: 100vw;
    background-color: #000;
    color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    ul.tot {
      li {
        &.cart span {
          font-size: 16px;
        }

        &.ship span {
          font-size: 16px;
        }

        &.total span {
          color: var(--greenb2b);
          font-size: 20px;
        }
      }
    }

    .link-ret {
      position: absolute;
      right: 10px;
      top: 50%;
      height: 60px;
      max-width: 300px;
      width: 100%;
      transform: translatey(-50%);


      //width: 21.85%;
      &.disabled {
        border: none;
        color: #edeff2;
        background-color: #c4c4c4;
      }
    }
    small {
      color: #de7d7d;
      width: 100%;
      position: absolute;
      left: 80%;
      top: 41%;
      -webkit-animation: vibrate-1 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
      animation: vibrate-1 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;

    }
    span {
      position: relative;
      font-size: 12px;

      &.tot {
        margin-right: 20px;
      }

      span.iva {
        position: absolute;
        top: 30px;
        left: 60px;
      }
    }
  }
}

@media (min-width: 576px) {
  .reserved {
    .ch-content {
      #ship_pay {
        .type {
          .ipad {
            flex-wrap: nowrap;
          }
        }

        .selection {
          font-size: 16px;

          flex-direction: row;

          label {
            top: 13px;
            left: 32px;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .reserved {
    ul.ch-menu {
      display: block;
    }

    .ch-header {
      .inactive {
        display: none;
      }
    }
  }
  .reserved .ch-footer .link-ret {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .reserved .ch-footer {
    span {
      position: relative;
      font-size: 24px;

      &.tot {
        margin-right: 100px;
      }

      span.iva {
        position: absolute;
        top: 30px;
        left: 60px;
        font-size: 15px;
      }
    }
  }
}

@media (min-width: 1200px) {
  .reserved {
    .ch-content {
      #ship_pay {
        .selection {
          label {
            width: auto;
          }
        }
      }
    }
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2022-2-8 22:28:50
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation vibrate-1
 * ----------------------------------------
 */
/* ----------------------------------------------
 * Generated by Animista on 2022-2-8 22:33:21
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation shake-horizontal
 * ----------------------------------------
 */
@-webkit-keyframes vibrate-1 {
  0%,
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70% {
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px);
  }
  20%,
  40%,
  60% {
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
  }
  80% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  90% {
    -webkit-transform: translateX(-8px);
    transform: translateX(-8px);
  }
}
@keyframes vibrate-1 {
  0%,
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70% {
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px);
  }
  20%,
  40%,
  60% {
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
  }
  80% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  90% {
    -webkit-transform: translateX(-8px);
    transform: translateX(-8px);
  }
}


</style>
